import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { PurchaseOrderModel } from './models/purchaseOrder.model'
import { PurchaseOrderFields } from './models/purchaseOrder_fields.model'

const API_URL = environment.apiUrl
@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderService {
  constructor(private http: HttpClient) {}

  addPurchaseOrder(purchaseOrder: PurchaseOrderModel) {
    
    return this.http
      .post(API_URL + '/PurchaseOrder/CreatePurchaseOrder', purchaseOrder, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  updatePurchaseOrder(purchaseOrder: PurchaseOrderModel) {
    
    return this.http
      .put(API_URL + '/PurchaseOrder/UpdatePurchaseOrder', purchaseOrder, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  deletePurchaseOrder(purchaseOrder: PurchaseOrderModel) {
    
    return this.http
      .put(API_URL + '/PurchaseOrder/DeletePurchaseOrder', purchaseOrder, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  getAllPurchaseOrders(): Observable<PurchaseOrderModel[]> {
    return this.http
      .get(API_URL + '/PurchaseOrder/GetPurchaseOrders', {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          

          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  getPurchaseOrderById(purchaseOrderId: number): Observable<PurchaseOrderModel> {
    return this.http
      .get(API_URL + '/PurchaseOrder/GetPurchaseOrderById', {
        params: {
          id: purchaseOrderId,
        },
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          

          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }
}
